function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export * from "@chakra-ui/theme-tools";
export * from "@chakra-ui/color-mode";
export { default as inMemoryStorageManager } from "./inMemoryStorageManager";
export * from "./useSemanticColorToken";
export { defineStyle, defineStyleConfig, withDefaultColorScheme, withDefaultProps, withDefaultSize, withDefaultVariant, createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { Box, DarkMode, LightMode, useColorMode, useColorModeValue as chakraUCMV } from "@chakra-ui/react";
import React, { useEffect } from "react";
export { DarkMode, LightMode, useColorMode };
/**
 * @deprecated in order of preference use a semantic token
 * then the `_dark` and `_light` elements in the theme of a component directly
 * then the `_dark` and `_light` props direclty
 */ export const useColorModeValue = chakraUCMV;
/**
 * @deprecated DarkModeBox / LightModeBox are deprecated. You only need to
 * use DarkMode and LightMode, which have the advantage of not creating a
 * useless div. If you don't see your UI changing color mode it means 2 things:
 * - if you created it yourself you're relying on a semantic token definition
 *   happening above your current DarkMode / LightBox usage so tokens values
 *   are not overriden in your component. To fix it simply respecify in your
 *   the semantic tokens you want to use for them to be updated:
 *   `<Box bg="semanticToken1"><DarkMode><Text color="semanticToken2" /></DarkMode><Box>`
 *   In this example, only the value of semanticToken2 is affected
 * - If you're directly using a Tempo component let us know, we'll see if we
 *   need to re-specify token usage direclty in the component's code or not.
 */ export const DarkModeBox = (_param)=>{
    var { children } = _param, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(DarkMode, {
        children: /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
            width: "100%",
            bg: "background.neutral.primary.default",
            color: "text.neutral.primary.default"
        }, props), {
            children: children
        }))
    });
};
/**
 * @deprecated DarkModeBox / LightModeBox are deprecated. You only need to
 * use DarkMode and LightMode, which have the advantage of not creating a
 * useless div. If you don't see your UI changing color mode it means 2 things:
 * - if you created it yourself you're relying on a semantic token definition
 *   happening above your current DarkMode / LightBox usage so tokens values
 *   are not overriden in your component. To fix it simply respecify in your
 *   the semantic tokens you want to use for them to be updated:
 *   `<Box bg="semanticToken1"><DarkMode><Text color="semanticToken2" /></DarkMode><Box>`
 *   In this example, only the value of semanticToken2 is affected
 * - If you're directly using a Tempo component let us know, we'll see if we
 *   need to re-specify token usage direclty in the component's code or not.
 */ export const LightModeBox = (_param)=>{
    var { children } = _param, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(LightMode, {
        children: /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
            width: "100%",
            bg: "background.neutral.primary.default",
            color: "text.neutral.primary.default"
        }, props), {
            children: children
        }))
    });
};
export const InverseMode = ({ children })=>{
    const { colorMode } = useColorMode();
    return colorMode === 'light' ? /*#__PURE__*/ _jsx(DarkMode, {
        children: children
    }) : /*#__PURE__*/ _jsx(LightMode, {
        children: children
    });
};
export const AppColorModeEnforcer = ({ colorMode })=>{
    const { colorMode: currentMode, setColorMode } = useColorMode();
    useEffect(()=>{
        if (currentMode !== colorMode) {
            setColorMode(colorMode);
        }
    }, [
        colorMode,
        currentMode,
        setColorMode
    ]);
    return null;
};

//# sourceMappingURL=index.js.map